/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Skip_Reason_StampInputs */

const cs_ebr_skip_reason_stamp = /** @type {(inputs: Ebr_Skip_Reason_StampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beze změny od posledního importu (razítko)`)
};

const en_ebr_skip_reason_stamp = /** @type {(inputs: Ebr_Skip_Reason_StampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unchanged since last import (stamp)`)
};

/**
* | output |
* | --- |
* | "Unchanged since last import (stamp)" |
*
* @param {Ebr_Skip_Reason_StampInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_skip_reason_stamp = /** @type {((inputs?: Ebr_Skip_Reason_StampInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Skip_Reason_StampInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_skip_reason_stamp(inputs)
	return cs_ebr_skip_reason_stamp(inputs)
});